import React from "react";
const MainWithoutResult = () => {
    return (
        <tr>
            <td colSpan={999999} style={{ textAlign: "center", width: "100%" }}>Sin resultados</td>
        </tr>
    )
}

export default MainWithoutResult;